import { parseHydration } from '../helpers';

class PageController {

	attributes = {
		uri: 'data-uri',
		pageType: 'data-page-type',
		previousPage: 'data-previous-page',
		currentPage: 'data-current-page'
	};

	container;

	pages = {};
	data = {};

	active;
	previous;

	activate() {
		const data = parseHydration(this.pages[this.active]);

		this.data[this.active] = data;

		document.title = data.seo[0]?.heading ?? `${data.title} | Good Measure`;

		if (this.previous) document.body.setAttribute(this.attributes.previousPage, this.previous);
		document.body.setAttribute(this.attributes.currentPage, this.active);

		document.body.setAttribute(this.attributes.pageType, data.sectionHandle);
		// console.log(this.active, data); // eslint-disable-line no-console
	}

	#createPage(uri) {
		this.pages[uri] = document.createElement('div');
		this.pages[uri].setAttribute(this.attributes.uri, uri);
	}

	initialize(container) {
		this.container = container;
	}

	detect() {
		const page = this.container.querySelector(`[${this.attributes.uri}]`);
		if (!page) return false;

		const uri = page.getAttribute(this.attributes.uri);

		this.previous = this.active;
		this.active = uri;

		this.pages[uri] = page;

		this.activate();

		return this.pages[uri];
	}

	async open(uri) {
		this.previous = this.active;
		this.active = uri;

		let path = '/';
		if (uri !== 'home') path += `${uri}/`;

		const html = await fetch(`${path}body.html`).then((res) => (res.ok ? res.text() : fetch('/404/body.html').then((r) => r.text())));

		if (this.pages[uri]) this.close(uri);
		this.#createPage(uri);
		this.pages[uri].innerHTML = html;
		this.container.appendChild(this.pages[uri]);

		this.activate();

		return this.pages[uri];
	}

	close(uri = this.active) {
		if (this.pages[uri]) {
			this.pages[uri].innerHTML = '';
			this.pages[uri].remove();
			delete this.pages[uri];
			delete this.data[uri];
		}
	}

}

export default new PageController();
